import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AApplicationRestClient } from "../a-application-rest.client";
import { ILauncherRestClient } from "./i-launcher-rest.client";

@Injectable()
export class LauncherRestClient extends AApplicationRestClient implements ILauncherRestClient {
  constructor(httpClient: HttpClient) {
    super( httpClient, 'launcher' );
  }
}
